import * as React from "react"
const SvgEmailAddress = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.714a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9 9.7 9.7 0 0 1 .788-3.9A10.1 10.1 0 0 1 4.925 5.64Q6.275 4.29 8.1 3.503a9.7 9.7 0 0 1 3.9-.788 9.7 9.7 0 0 1 3.9.788 10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9v1.45q0 1.475-1.012 2.513c-1.012 1.038-1.505 1.037-2.488 1.037a3.74 3.74 0 0 1-1.65-.375 3.5 3.5 0 0 1-1.3-1.075 4.8 4.8 0 0 1-1.638 1.088 5.1 5.1 0 0 1-1.912.362q-2.075 0-3.537-1.462Q7 14.79 7 12.714t1.463-3.537Q9.925 7.714 12 7.714c2.075 0 2.563.488 3.537 1.463Q17 10.639 17 12.714v1.45q0 .65.425 1.1t1.075.45 1.075-.45.425-1.1v-1.45q0-3.35-2.325-5.675T12 4.714 6.325 7.039 4 12.714t2.325 5.675T12 20.714h4q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287zm0-7a2.9 2.9 0 0 0 2.125-.875A2.9 2.9 0 0 0 15 12.714q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 9.714q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 12.714q0 1.25.875 2.125a2.9 2.9 0 0 0 2.125.875" />
  </svg>
)
export default SvgEmailAddress
